<template>
  <main-layout>

    <!-- Header moderno -->
    <PageHeader icon="ri-dashboard-line" title="Mi Espacio Académico" :show-button="false" button-text="Actualizar"
      button-icon="ri-loop-right-line" />

    <div class="content-container">

      <!-- Sección de Progreso -->
      <div class="progress-section">
        <div class="progress-container">

          <!-- Progreso Actual -->
          <div class="progress-item" :class="`${actualProgressClass}-parent`">
            <div class="progress-header">
              <div class="progress-label">
                <i class="ri-time-line"></i>
                <span>Mi Avance Actual</span>
              </div>
              <div class="progress-percentage" :class="actualProgressClass">{{ Math.trunc(avanceActual) }}%</div>
            </div>
            <div class="progress-bar-wrapper">
              <div class="progress-bar-container">
                <div class="progress-bar-bg">
                  <div class="progress-bar-fill actual-fill" :class="actualProgressClass"
                    :style="{ width: avanceActual + '%' }">
                    <div class="progress-shimmer"></div>
                  </div>
                </div>
              </div>
              <!-- Osito animado que se mueve con el progreso -->
              <div class="bear-container" :style="{ left: avanceActual + '%' }">
                <img src="/gifs/oso_caminando.gif" alt="Progreso" class="bear-gif" />
              </div>
            </div>
            <p class="progress-description">Tu progreso en el programa académico</p>
          </div>

          <!-- Progreso Esperado -->
          <div class="progress-item">
            <div class="progress-header">
              <div class="progress-label">
                <i class="ri-checkbox-circle-line"></i>
                <span>Avance Esperado</span>
              </div>
              <div class="progress-percentage expected">{{ Math.trunc(avanceEsperado) }}%</div>
            </div>
            <div class="progress-bar-container">
              <div class="progress-bar-bg">
                <div class="progress-bar-fill expected-fill" :style="{ width: avanceEsperado + '%' }">
                  <div class="progress-shimmer"></div>
                </div>
              </div>
            </div>
            <p class="progress-description">Cómo deberías ir según el cronograma</p>
          </div>

          <!-- Indicador de Estado -->
          <div class="progress-status" :class="statusClass">
            <i v-if="statusClass === 'ahead'" class="ri-arrow-up-line"></i>
            <i v-else-if="statusClass === 'behind'" class="ri-arrow-down-line"></i>
            <i v-else class="ri-check-line"></i>
            <span>{{ statusText }}</span>
          </div>
          <AccionesEstudiante/>
        </div>
      </div>



      <!-- Aviso de encuesta de satisfacción pendiente -->
      <div v-if="avisoEncuesta" class="survey-notice" role="status">
        <div class="survey-notice-icon" aria-hidden="true">
          <i class="ri-survey-line"></i>
        </div>
        <div class="survey-notice-text">
          <strong>Encuesta de satisfacción pendiente</strong>
          <span>{{ avisoEncuestaTexto }}</span>
          <span v-if="encuestaMotivo" class="survey-notice-motivo">{{ encuestaMotivo }}</span>
        </div>
        <router-link :to="{ name: 'encuesta_satisfaccion', params: { id: encuestaPendiente.id } }"
          class="survey-notice-action">
          Responder encuesta
          <i class="ri-arrow-right-line"></i>
        </router-link>
      </div>

      <!-- Dashboard Grid -->
      <div class="dashboard-container">
        <!-- Caja Principal: Programar -->
        <div class="main-card card-programar" @click="$router.push({ name: 'programar' })">
          <div class="card-glow"></div>
          <div class="card-content">
            <div class="card-icon-wrapper">
              <div class="icon-composition icon-composition-main">
                <img src="@/assets/custom-icons/book_2.svg" alt="Programar" class="custom-icon-main" />
              </div>
            </div>
            <div class="card-top-line"></div>
            <h2 class="card-title">BOOK MY CLASS</h2>
            <p class="card-subtitle-secondary">Programar mi Clase</p>
            <div class="card-bottom-line"></div>
          </div>
        </div>

        <!-- Cajas Secundarias -->
        <div class="secondary-card card-clases" @click="$router.push({ name: 'mis_clases' })">
          <div class="card-content-secondary">
            <div class="card-icon-small">
              <div class="icon-composition icon-composition-clases">
                <img src="@/assets/custom-icons/check_2.svg" alt="Mis Clases" class="custom-icon-secondary" />
              </div>
            </div>
            <div class="card-top-line"></div>
            <h3 class="card-title-secondary">MY BOOKED CLASSES</h3>
            <p class="card-subtitle-secondary">Mis Clases Programadas</p>
            <div class="card-bottom-line"></div>
          </div>
        </div>

        <div class="secondary-card card-registro" @click="$router.push({ name: 'registro_academico' })">
          <div class="card-content-secondary">
            <div class="card-icon-small">
              <div class="icon-composition icon-composition-registro">
                <img src="@/assets/custom-icons/progreso_2.svg" alt="Progreso Académico" class="custom-icon-secondary" />
              </div>
            </div>
            <div class="card-top-line"></div>
            <h3 class="card-title-secondary">MY ACADEMIC PROGRESS</h3>
            <p class="card-subtitle-secondary">Mi Progreso Académico</p>
            <div class="card-bottom-line"></div>
          </div>
        </div>

        <div class="secondary-card card-evaluaciones" @click="$router.push({ name: 'evaluaciones' })">
          <div class="card-content-secondary">
            <div class="card-icon-small">
              <div class="icon-composition icon-composition-evaluaciones">
                <img src="@/assets/custom-icons/check_agenda_2.svg" alt="Evaluaciones" class="custom-icon-secondary" />
              </div>
            </div>
            <div class="card-top-line"></div>
            <h3 class="card-title-secondary">MY ASSESSMENT</h3>
            <p class="card-subtitle-secondary">Mis Evaluaciones</p>
            <div class="card-bottom-line"></div>
          </div>
        </div>

        <div class="secondary-card card-apoyo" @click="$router.push({ name: 'apoyo_estudiantil' })">
          <div class="card-content-secondary">
            <div class="card-icon-small">
              <div class="icon-composition icon-composition-apoyo">
                <img src="@/assets/custom-icons/bombillo_2.svg" alt="Apoyo estudiantil" class="custom-icon-apoyo" />
              </div>
            </div>
            <div class="card-top-line"></div>
            <h3 class="card-title-secondary">STUDENT SUPPORT</h3>
            <p class="card-subtitle-secondary">Apoyo Estudiantil</p>
            <div class="card-bottom-line"></div>
          </div>
        </div>

        <div v-if="tutoriasHabilitadas" class="secondary-card card-tutorias"
          @click="$router.push({ name: 'mis_tutorias' })">
          <div class="card-content-secondary">
            <div class="card-icon-small">
              <div class="icon-composition icon-composition-tutorias">
                <img src="@/assets/custom-icons/tutorias_2.svg" alt="Tutorías" class="custom-icon-secondary" />
              </div>
            </div>
            <div class="card-top-line"></div>
            <h3 class="card-title-secondary">TUTORING SESSIONS</h3>
            <p class="card-subtitle-secondary">Tutorías</p>
            <div class="card-bottom-line"></div>
          </div>
        </div>

      </div>

    </div>

  </main-layout>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import MainLayout from './Layout/MainLayout.vue';
import PageHeader from './Layout/PageHeader.vue';
import AccionesEstudiante from '@/features/nivel/components/AccionesEstudiante.vue';

export default {
  name: 'programaciones',
  components: {
    MainLayout,
    PageHeader,
    AccionesEstudiante
  },
  data() {
    return {
      isRefreshing: false,
      avanceActual: 0,
      avanceEsperado: 0
    }
  },
  mounted() {
    // El backend ya filtra por nivel, sede y progreso mínimo: todo lo que devuelve le aplica al estudiante
    this.fetchEncuestasPendientes();
    // El recorrido inicia cuando ya cargó el avance, para no apuntar a una sección a medio renderizar
    this.actualizar()
      .finally(() => this.iniciarRecorrido())
      .catch(() => {});
  },
  beforeDestroy() {
    // Si sale de Inicio con el recorrido abierto, no se marca como visto
    this.saliendo = true;
    if (this.recorrido) {
      this.recorrido.destroy();
    }
  },

  methods: {
    ...mapActions({
      fetchProgramaciones: 'student/fetchProgramaciones',
      progreso: 'student/progreso',
      actualizarShowNewUpdates: 'auth/actualizarShowNewUpdates',
      fetchEncuestasPendientes: 'encuestaSatisfaccion/fetchPendientes'
    }),
    ...mapMutations({
      setRecorridoActivo: 'auth/setRecorridoActivo'
    }),
    actualizar() {
      this.isRefreshing = true;
      this.fetchProgramaciones();
      const progreso = this.fetchProgreso();
      setTimeout(() => {
        this.isRefreshing = false;
      }, 1000);
      return progreso;
    },
    iniciarRecorrido() {
      if (!this.mostrarRecorrido || this.recorrido) return;

      this.recorrido = this.$driver({
        steps: [
          {
            popover: {
              title: '¡Te damos la bienvenida al nuevo look & feel de Blocks!',
              description: 'Renovamos la plataforma para que tu experiencia sea más clara, cómoda y sencilla. Te invitamos a conocerla en un recorrido breve.'
            }
          },
          {
            element: '.progress-section',
            popover: {
              title: 'Tu avance',
              description: 'Aquí puedes consultar tu avance actual y compararlo con el avance esperado según el cronograma, para saber cómo vas en tu proceso.',
              side: 'bottom',
              align: 'center'
            }
          },
          {
            element: '.card-programar',
            popover: {
              title: 'Programa tu clase',
              description: 'Desde el inicio puedes acceder a las principales funcionalidades. Esta es la principal: aquí programas tu próxima clase de forma rápida y sencilla.',
              side: 'top',
              align: 'center'
            }
          },
          {
            element: '.card-clases',
            popover: {
              title: 'Mis clases programadas',
              description: 'Consulta aquí todas tus clases programadas y administra tu agenda con facilidad.',
              side: 'top',
              align: 'center'
            }
          },
          {
            element: '.card-registro',
            popover: {
              title: 'Mi progreso académico',
              description: 'Revisa el detalle de lo que has completado hasta ahora y el estado de tu proceso académico.',
              side: 'top',
              align: 'center'
            }
          },
          {
            element: '.card-evaluaciones',
            popover: {
              title: 'Mis evaluaciones',
              description: 'Consulta tus evaluaciones y sus resultados en un solo lugar.',
              side: 'top',
              align: 'center'
            }
          },
          {
            element: '.card-apoyo',
            popover: {
              title: 'Apoyo estudiantil',
              description: 'Si necesitas orientación o tienes alguna inquietud, aquí encontrarás los recursos para recibir ayuda.',
              side: 'top',
              align: 'center'
            }
          },
          {
            element: '.theme-toggle-btn',
            popover: {
              title: 'Tema claro u oscuro',
              description: 'Cambia entre tema claro y oscuro cuando lo prefieras, según lo que te resulte más cómodo.',
              side: 'bottom',
              align: 'end'
            }
          },
          {
            element: '.nav-account',
            popover: {
              title: 'Notificaciones y perfil',
              description: 'En las notificaciones encontrarás los avisos importantes. Desde tu perfil puedes revisar tus datos y cerrar sesión.',
              side: 'bottom',
              align: 'end'
            }
          },
          {
            popover: {
              title: 'Esperamos que disfrutes la nueva experiencia',
              description: 'Diseñamos esta nueva versión pensando en ti y esperamos que te guste. Gracias por ser parte de Blocks.',
              doneBtnText: 'Empezar'
            }
          }
        ],
        // Se dispara tanto al finalizar como al cerrar el recorrido
        onDestroyed: () => {
          this.recorrido = null;
          this.setRecorridoActivo(false);
          if (this.saliendo) return;
          this.actualizarShowNewUpdates(0).catch(() => {});
        }
      });
      // App.vue oculta los mensajes modernos mientras dure el recorrido
      this.setRecorridoActivo(true);
      this.recorrido.drive();
    },
    fetchProgreso() {
      return this.progreso().then(response => {

        const avancePorClase = 100 / response.total;

        // 168 días (6 meses) o lo que le quede de vigencia si tiene siguiente nivel
        const diasDisponibles = (response.dias_vigencia_disponible < 168 && response.tiene_nivel_siguiente) ? response.dias_vigencia_disponible : 168;
        const avancePorDia = 100 / diasDisponibles;

        this.avanceActual = response.total_clases * avancePorClase;

        if (response.diferencia_dias >= 168) {
          this.avanceEsperado = 100; // Limitar el avance esperado al 100% si han pasado 168 días o más
        } else {
          const avance = response.diferencia_dias * avancePorDia;
          this.avanceEsperado = avance >= 100 ? 100 : avance;
        }

        /* this.avanceEsperado = response.avanceEsperado;
        this.avanceActual = response.avanceActual; */

      })
    }
  },
  computed: {
    ...mapState({
      programaciones: state => state.student.programaciones,
      variables: state => state.student.variables
    }),
    ...mapGetters({
      formattedClases: 'academico/formattedClases',
      mostrarRecorrido: 'auth/recorridoPendiente',
      encuestaPendiente: 'encuestaSatisfaccion/encuestaPendiente'
    }),
    avisoEncuesta() {
      return !!this.encuestaPendiente;
    },
    // Motivo de obligatoriedad como texto plano; vacío si es null o no tiene contenido
    encuestaMotivo() {
      const motivo = this.encuestaPendiente && this.encuestaPendiente.motivo_obligatoriedad;
      return typeof motivo === 'string' && motivo.trim() !== '' ? motivo.trim() : '';
    },
    avisoEncuestaTexto() {
      return this.encuestaPendiente && this.encuestaPendiente.obligatoria
        ? 'Es necesario que respondas la encuesta de satisfacción. Tu opinión nos ayuda a mejorar.'
        : 'Te invitamos a responder la encuesta de satisfacción. Tu opinión nos ayuda a mejorar.';
    },
    tutoriasHabilitadas() {
      return this.variables && this.variables.habilitar_tutoria == 1 ? true : false;
    },
    actualProgressClass() {
      const diferencia = this.avanceActual - this.avanceEsperado;
      if (diferencia >= 10) return 'actual-ahead'; // Verde: está por encima del progreso esperado hasta en un 10% o más
      if (diferencia <= -10) return 'actual-danger'; // Rojo: está por debajo del progreso esperado en un 10% o más
      return 'actual-warning'; // azul: está dentro del rango de ±10% del progreso esperado
    },
    statusClass() {
      const diferencia = this.avanceActual - this.avanceEsperado;
      if (diferencia >= 10) return 'ahead';
      if (diferencia <= -10) return 'behind';
      return 'ontrack';
    },
    statusText() {
      const diferencia = this.avanceActual - this.avanceEsperado;
      if (diferencia >= 10) return '¡Vas mejor de lo planeado! ¡Sigue avanzando!';
      if (diferencia <= -10) return 'Vas un poco atrás. ¡Aún puedes ponerte al día!';
      return 'Vas según lo planeado. ¡Sigue así!';
    },
  }
}
</script>

<style scoped>
/* Aviso de encuesta de satisfacción */
.survey-notice {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: rgba(13, 78, 140, 0.1);
  border: 1px solid var(--theme-border-color);
  border-left: 4px solid var(--app-primary-blue);
  border-radius: 14px;
  animation: fadeInUp 0.6s ease-out;
}

.survey-notice-icon {
  display: grid;
  place-items: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  background: var(--theme-gradient-primary);
  border-radius: 12px;
  color: #fff;
}

.survey-notice-text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  flex: 1;
  min-width: 0;
  color: var(--theme-text-secondary);
  font-size: 0.9rem;
  line-height: 1.5;
}

.survey-notice-motivo {
  white-space: pre-line;
}

.survey-notice-text strong {
  color: var(--theme-text-primary);
  font-size: 0.95rem;
}

.survey-notice-action {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  padding: 0.6rem 1rem;
  background: var(--theme-gradient-primary);
  border-radius: 10px;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  box-shadow: var(--theme-shadow-sm);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.survey-notice-action:hover {
  color: #fff;
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: var(--theme-shadow-md);
}

@media (max-width: 768px) {
  .survey-notice {
    flex-direction: column;
    align-items: stretch;
    text-align: left;
  }

  .survey-notice-action {
    justify-content: center;
  }
}

/* Sección de Progreso */
.progress-section {
  position: relative;
  z-index: 1;
}

.progress-container {
  background: var(--theme-bg-card);
  backdrop-filter: blur(20px);
  border: 1px solid var(--theme-border-color);
  border-radius: 20px;
  padding: 1.5rem;
  box-shadow: var(--theme-shadow-lg);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  animation: fadeInUp 0.6s ease-out;
}

.progress-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.progress-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--theme-text-primary);
}

.progress-label svg {
  flex-shrink: 0;
}

.progress-item:first-child .progress-label svg {
  color: var(--theme-text-secondary);
}

.progress-item:first-child.actual-ahead-parent .progress-label svg {
  color: #34c759;
}

.progress-item:first-child.actual-warning-parent .progress-label svg {
  color: #ff9500;
}

.progress-item:first-child.actual-danger-parent .progress-label svg {
  color: #ff3b30;
}

.progress-item:nth-child(2) .progress-label svg {
  color: var(--app-primary-blue);
}

.progress-percentage {
  font-size: 1.5rem;
  font-weight: 700;
  background: var(--theme-gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
}

.progress-percentage.expected {
  background: var(--theme-gradient-progress-success);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.progress-percentage.actual-ahead {
  background: var(--theme-gradient-secondary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.progress-percentage.actual-warning {
  background: var(--theme-gradient-progress-success);
  /* background: linear-gradient(135deg, #ff9500 0%, #ffb340 100%); */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.progress-percentage.actual-danger {
  background: var(--theme-gradient-progress-danger);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.progress-bar-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
}

.progress-bar-container {
  width: 100%;
}

.progress-bar-bg {
  width: 100%;
  height: 14px;
  background: var(--theme-input-bg);
  border-radius: 100px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.progress-bar-fill {
  height: 100%;
  border-radius: 100px;
  position: relative;
  transition: width 1s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.progress-bar-fill.expected-fill {
  background: var(--theme-gradient-progress-success);
  box-shadow: 0 0 20px rgba(13, 78, 140, 0.5);
}

.progress-bar-fill.actual-fill.actual-ahead {
  background: var(--theme-gradient-secondary);
  box-shadow: 0 0 20px rgba(13, 78, 140, 0.5);
}

.progress-bar-fill.actual-fill.actual-warning {
  background: var(--theme-gradient-progress-success);
  box-shadow: 0 0 20px rgba(13, 78, 140, 0.5);
}

.progress-bar-fill.actual-fill.actual-danger {
  background: var(--theme-gradient-progress-danger);
  box-shadow: 0 0 20px rgba(255, 59, 48, 0.5);
}

.progress-shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

.bear-container {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  transition: left 1s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}

.bear-gif {
  width: 48px;
  height: 48px;
  object-fit: contain;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2));
  animation: bearWalk 0.8s ease-in-out infinite;
}

@keyframes bearWalk {

  0%,
  100% {
    transform: translateY(0) scale(1);
  }

  50% {
    transform: translateY(-3px) scale(1.05);
  }
}

.progress-description {
  font-size: 0.8125rem;
  color: var(--theme-text-secondary);
  margin: 0;
  font-weight: 500;
}

.progress-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.progress-status svg {
  flex-shrink: 0;
}

.progress-status.ahead {
  color: var(--theme-color-info);
}

.progress-status.ahead svg {
  color: var(--theme-color-info);
  animation: bounce 1s ease-in-out infinite;
}

.progress-status.behind {
  color: var(--theme-color-danger);
}

.progress-status.behind svg {
  color: var(--theme-color-danger);
  animation: bounce 1s ease-in-out infinite;
}

.progress-status.ontrack {
  color: var(--theme-color-info);
}

.progress-status.ontrack svg {
  color: var(--theme-color-info);
}

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-5px);
  }
}

/* Dashboard Container */
.dashboard-container {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

/* Card Principal - Programar */
.main-card {
  width: 100%;
  flex: 1 1 100%;
  position: relative;
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.1) 0%,
      rgba(79, 172, 254, 0.3) 50%,
      rgba(13, 78, 140, 0.1) 100%);
  border: 1px solid var(--theme-border-color-strong);
  border-radius: 20px;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: var(--theme-backdrop-blur);
  animation: fadeInUp 0.6s ease-out 0.1s both;
  display: flex;
  flex-direction: column;
}

.card-top-line {
  width: 100%;
  height: 3px;
  background: var(--theme-gradient-primary);
  position: relative;
  z-index: 3;
  border-radius: 2px;
  margin: 1rem 0;
}

.card-bottom-line {
  width: 100%;
  height: 3px;
  background: var(--theme-gradient-primary);
  position: relative;
  z-index: 3;
  border-radius: 2px;
  margin: 1rem 0 0;
}

.main-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--theme-shadow-xl);
  border-color: var(--theme-border-color-strong);
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.22) 0%,
      rgba(79, 172, 254, 0.22) 50%,
      rgba(13, 78, 140, 0.22) 100%);
}


@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: var(--theme-radial-primary);
  opacity: 0;
  transition: opacity 0.5s ease;
  pointer-events: none;
}

.main-card:hover .card-glow {
  opacity: 1;
}

.card-content {
  position: relative;
  z-index: 2;
  padding: 2rem 2.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: var(--theme-gradient-primary);
  border-radius: 20px;
  margin: 0 auto 1rem;
  box-shadow: var(--theme-shadow-md);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.main-card:hover .card-icon-wrapper {
  transform: scale(1.1) rotate(5deg);
}

.card-icon {
  color: white;
}

/* ============================================================================
   COMPOSICIONES DE ICONOS - IMAGENES PERSONALIZADAS
   ============================================================================ */

/* Composición base */
.icon-composition {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Icono principal - Programar */
.custom-icon-main {
  width: 48px;
  height: 48px;
  object-fit: contain;
  filter: brightness(1) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  transition: all 0.3s ease;
}

/* .light-theme .custom-icon-main {
  filter: brightness(0) saturate(100%) invert(20%) sepia(80%) saturate(1500%) hue-rotate(190deg) brightness(95%) contrast(95%) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
} */

.main-card:hover .custom-icon-main {
  transform: scale(1.05);
  /* filter: brightness(1.1) drop-shadow(0 4px 8px rgba(255, 255, 255, 0.3)); */
}

/* .light-theme .main-card:hover .custom-icon-main {
  filter: brightness(0) saturate(100%) invert(20%) sepia(90%) saturate(1800%) hue-rotate(190deg) brightness(100%) contrast(100%) drop-shadow(0 4px 8px rgba(13, 78, 140, 0.3));
} */

/* Iconos secundarios */
.custom-icon-secondary {
  width: 40px;
  height: 40px;
  object-fit: contain;
  filter: brightness(1) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
  transition: all 0.3s ease;
}

.custom-icon-tutoria {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  line-height: 1;
  color: var(--theme-text-primary);
}

/* ============================================================================
   FILTROS DE COLOR PERSONALIZADOS TEMA CLARO (COMENTADOS - USO FUTURO)
   ============================================================================ */

/* AZUL - Mis Clases */
/* .light-theme .card-clases .custom-icon-secondary {
  filter: brightness(0) saturate(100%) invert(50%) sepia(80%) saturate(1000%) hue-rotate(180deg) brightness(95%) contrast(100%) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
} */

/* ROJO - Progreso Académico */
/* .light-theme .card-registro .custom-icon-secondary {
  filter: brightness(0) saturate(100%) invert(20%) sepia(80%) saturate(1500%) hue-rotate(340deg) brightness(90%) contrast(90%) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
} */

/* AMARILLO - Evaluaciones */
/* .light-theme .card-evaluaciones .custom-icon-secondary {
  filter: brightness(0) saturate(100%) invert(80%) sepia(60%) saturate(2000%) hue-rotate(10deg) brightness(100%) contrast(100%) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
} */

/* CYAN - Tutorías */
/* .light-theme .card-tutorias .custom-icon-secondary {
  filter: brightness(0) saturate(100%) invert(50%) sepia(80%) saturate(1000%) hue-rotate(180deg) brightness(95%) contrast(100%) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
} */

/* ============================================================================
   FILTRO AZUL UNIVERSAL TEMA CLARO (ACTIVO)
   ============================================================================ */
.light-theme .card-clases .custom-icon-secondary,
.light-theme .card-registro .custom-icon-secondary,
.light-theme .card-evaluaciones .custom-icon-secondary,
.light-theme .card-tutorias .custom-icon-secondary {
  filter: brightness(0) saturate(100%) invert(50%) sepia(80%) saturate(1000%) hue-rotate(180deg) brightness(95%) contrast(100%) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

/* Hover effects */
.secondary-card:hover .custom-icon-secondary {
  transform: scale(1.05);
}

/* ============================================================================
   HOVER ICONOS PERSONALIZADOS POR COLOR (COMENTADOS - USO FUTURO)
   ============================================================================ */

/* AZUL - Mis Clases */
/* .card-clases:hover .custom-icon-secondary {
  filter: brightness(1.1) drop-shadow(0 4px 8px rgba(79, 172, 254, 0.4));
}

.light-theme .card-clases:hover .custom-icon-secondary {
  filter: brightness(0) saturate(100%) invert(50%) sepia(90%) saturate(1200%) hue-rotate(180deg) brightness(100%) contrast(105%) drop-shadow(0 4px 8px rgba(13, 78, 140, 0.3));
} */

/* ROJO - Progreso Académico */
/* .card-registro:hover .custom-icon-secondary {
  filter: brightness(1.1) drop-shadow(0 4px 8px rgba(220, 60, 80, 0.4));
}

.light-theme .card-registro:hover .custom-icon-secondary {
  filter: brightness(0) saturate(100%) invert(20%) sepia(90%) saturate(1800%) hue-rotate(340deg) brightness(95%) contrast(95%) drop-shadow(0 4px 8px rgba(188, 35, 54, 0.3));
} */

/* AMARILLO - Evaluaciones */
/* .card-evaluaciones:hover .custom-icon-secondary {
  filter: brightness(1.1) drop-shadow(0 4px 8px rgba(255, 215, 0, 0.5));
}

.light-theme .card-evaluaciones:hover .custom-icon-secondary {
  filter: brightness(0) saturate(100%) invert(80%) sepia(70%) saturate(2500%) hue-rotate(10deg) brightness(105%) contrast(105%) drop-shadow(0 4px 8px rgba(241, 196, 0, 0.4));
} */

/* CYAN - Tutorías */
/* .card-tutorias:hover .custom-icon-secondary {
  filter: brightness(1.1) drop-shadow(0 4px 8px rgba(79, 172, 254, 0.4));
}

.light-theme .card-tutorias:hover .custom-icon-secondary {
  filter: brightness(0) saturate(100%) invert(50%) sepia(90%) saturate(1200%) hue-rotate(180deg) brightness(100%) contrast(105%) drop-shadow(0 4px 8px rgba(79, 172, 254, 0.3));
} */

/* ============================================================================
   HOVER ICONOS AZUL UNIVERSAL (ACTIVO)
   ============================================================================ */
.card-clases:hover .custom-icon-secondary,
.card-registro:hover .custom-icon-secondary,
.card-evaluaciones:hover .custom-icon-secondary,
.card-tutorias:hover .custom-icon-secondary {
  filter: brightness(1.1) drop-shadow(0 4px 8px rgba(79, 172, 254, 0.4));
}

.light-theme .card-clases:hover .custom-icon-secondary,
.light-theme .card-registro:hover .custom-icon-secondary,
.light-theme .card-evaluaciones:hover .custom-icon-secondary,
.light-theme .card-tutorias:hover .custom-icon-secondary {
  filter: brightness(0) saturate(100%) invert(50%) sepia(90%) saturate(1200%) hue-rotate(180deg) brightness(100%) contrast(105%) drop-shadow(0 4px 8px rgba(13, 78, 140, 0.3));
}

/* Icono de Apoyo Estudiantil - Bombillo */
/* ============================================================================
   COLOR VERDE PERSONALIZADO (COMENTADO - USO FUTURO)
   ============================================================================ */
/* .custom-icon-apoyo {
  font-size: 2rem;
  color: rgba(52, 199, 89, 1);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
  transition: all 0.3s ease;
}

.light-theme .custom-icon-apoyo {
  color: rgba(52, 199, 89, 1);
}

.card-apoyo:hover .custom-icon-apoyo {
  transform: scale(1.05);
  filter: drop-shadow(0 4px 8px rgba(52, 199, 89, 0.4));
}

.light-theme .card-apoyo:hover .custom-icon-apoyo {
  filter: drop-shadow(0 4px 8px rgba(52, 199, 89, 0.4));
} */

/* ============================================================================
   COLOR AZUL UNIVERSAL (ACTIVO)
   ============================================================================ */
.custom-icon-apoyo {
  width: 40px;
  height: 40px;
  display: block;
  object-fit: contain;
  filter: brightness(0) invert(1) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
  transition: all 0.3s ease;
}

.light-theme .custom-icon-apoyo {
  filter: brightness(0) saturate(100%) invert(50%) sepia(80%) saturate(1000%) hue-rotate(180deg) brightness(95%) contrast(100%) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
}

.card-apoyo:hover .custom-icon-apoyo {
  transform: scale(1.05);
  filter: brightness(0) invert(1) drop-shadow(0 4px 8px rgba(255, 255, 255, 0.4));
}

.light-theme .card-apoyo:hover .custom-icon-apoyo {
  filter: brightness(0) saturate(100%) invert(50%) sepia(80%) saturate(1000%) hue-rotate(180deg) brightness(95%) contrast(100%) drop-shadow(0 4px 8px rgba(79, 172, 254, 0.4));
}

/* Responsive adjustments */
.card-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-shadow:
    0 2px 4px rgba(0, 0, 0, 0.1),
    0 4px 8px rgba(13, 78, 140, 0.15),
    0 1px 2px rgba(255, 255, 255, 0.1);
}

/* Cards Secundarias */
.secondary-card {
  position: relative;
  min-height: 220px;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 20px;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: var(--theme-backdrop-blur);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
}

@media (min-width: 768px) {
  .secondary-card {
    flex: 1 1 calc(50% - 0.75rem);
    min-width: 200px;
  }
}

@media (min-width: 1024px) {
  .secondary-card {
    flex: 1 1 calc(25% - 1.125rem);
    min-width: 180px;
  }
}

/* Fondos específicos para cada card secundaria */
/* ============================================================================
   COLORES PERSONALIZADOS POR CARD (COMENTADOS - USO FUTURO)
   ============================================================================ */

/* AZUL - Mis Clases */
/* .card-clases {
  animation: fadeInUp 0.6s ease-out 0.15s both;
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.15) 0%,
      rgba(79, 172, 254, 0.12) 100%);
}

.light-theme .card-clases {
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.12) 0%,
      rgba(79, 172, 254, 0.1) 100%);
} */

/* ROJO - Progreso Académico */
/* .card-registro {
  animation: fadeInUp 0.6s ease-out 0.2s both;
  background: linear-gradient(135deg,
      rgba(188, 35, 54, 0.15) 0%,
      rgba(188, 35, 54, 0.08) 100%);
}

.light-theme .card-registro {
  background: linear-gradient(135deg,
      rgba(188, 35, 54, 0.12) 0%,
      rgba(188, 35, 54, 0.06) 100%);
} */

/* AMARILLO - Evaluaciones */
/* .card-evaluaciones {
  animation: fadeInUp 0.6s ease-out 0.3s both;
  background: linear-gradient(135deg,
      rgba(241, 196, 0, 0.15) 0%,
      rgba(255, 215, 0, 0.1) 100%);
}

.light-theme .card-evaluaciones {
  background: linear-gradient(135deg,
      rgba(241, 196, 0, 0.12) 0%,
      rgba(255, 215, 0, 0.08) 100%);
} */

/* VERDE - Apoyo Estudiantil */
/* .card-apoyo {
  animation: fadeInUp 0.6s ease-out 0.4s both;
  background: linear-gradient(135deg,
      rgba(52, 199, 89, 0.15) 0%,
      rgba(93, 226, 120, 0.1) 100%);
}

.light-theme .card-apoyo {
  background: linear-gradient(135deg,
      rgba(52, 199, 89, 0.12) 0%,
      rgba(93, 226, 120, 0.08) 100%);
} */

/* CYAN - Tutorías */
/* .card-tutorias {
  animation: fadeInUp 0.6s ease-out 0.5s both;
  background: linear-gradient(135deg,
      rgba(79, 172, 254, 0.15) 0%,
      rgba(0, 242, 254, 0.1) 100%);
}

.light-theme .card-tutorias {
  background: linear-gradient(135deg,
      rgba(79, 172, 254, 0.12) 0%,
      rgba(0, 242, 254, 0.08) 100%);
} */

/* ============================================================================
   COLOR UNIVERSAL AZUL CORPORATIVO (ACTIVO)
   ============================================================================ */
.card-clases,
.card-registro,
.card-evaluaciones,
.card-apoyo,
.card-tutorias {
  animation: fadeInUp 0.6s ease-out 0.15s both;
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.15) 0%,
      rgba(79, 172, 254, 0.12) 100%);
}

.light-theme .card-clases,
.light-theme .card-registro,
.light-theme .card-evaluaciones,
.light-theme .card-apoyo,
.light-theme .card-tutorias {
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.12) 0%,
      rgba(79, 172, 254, 0.1) 100%);
}

.secondary-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--theme-shadow-md);
  border-color: var(--theme-border-color-strong);
}

/* Hover con intensidad de color aumentada */
/* ============================================================================
   HOVERS PERSONALIZADOS POR COLOR (COMENTADOS - USO FUTURO)
   ============================================================================ */

/* AZUL - Mis Clases */
/* .card-clases:hover {
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.22) 0%,
      rgba(79, 172, 254, 0.18) 100%);
}

.light-theme .card-clases:hover {
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.18) 0%,
      rgba(79, 172, 254, 0.14) 100%);
} */

/* ROJO - Progreso Académico */
/* .card-registro:hover {
  background: linear-gradient(135deg,
      rgba(188, 35, 54, 0.22) 0%,
      rgba(188, 35, 54, 0.14) 100%);
}

.light-theme .card-registro:hover {
  background: linear-gradient(135deg,
      rgba(188, 35, 54, 0.18) 0%,
      rgba(188, 35, 54, 0.10) 100%);
} */

/* AMARILLO - Evaluaciones */
/* .card-evaluaciones:hover {
  background: linear-gradient(135deg,
      rgba(241, 196, 0, 0.22) 0%,
      rgba(255, 215, 0, 0.16) 100%);
}

.light-theme .card-evaluaciones:hover {
  background: linear-gradient(135deg,
      rgba(241, 196, 0, 0.18) 0%,
      rgba(255, 215, 0, 0.12) 100%);
} */

/* VERDE - Apoyo Estudiantil */
/* .card-apoyo:hover {
  background: linear-gradient(135deg,
      rgba(52, 199, 89, 0.22) 0%,
      rgba(93, 226, 120, 0.16) 100%);
}

.light-theme .card-apoyo:hover {
  background: linear-gradient(135deg,
      rgba(52, 199, 89, 0.18) 0%,
      rgba(93, 226, 120, 0.12) 100%);
} */

/* CYAN - Tutorías */
/* .card-tutorias:hover {
  background: linear-gradient(135deg,
      rgba(79, 172, 254, 0.22) 0%,
      rgba(0, 242, 254, 0.16) 100%);
}

.light-theme .card-tutorias:hover {
  background: linear-gradient(135deg,
      rgba(79, 172, 254, 0.18) 0%,
      rgba(0, 242, 254, 0.12) 100%);
} */

/* ============================================================================
   HOVER UNIVERSAL AZUL CORPORATIVO (ACTIVO)
   ============================================================================ */
.card-clases:hover,
.card-registro:hover,
.card-evaluaciones:hover,
.card-apoyo:hover,
.card-tutorias:hover {
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.22) 0%,
      rgba(79, 172, 254, 0.18) 100%);
}

.light-theme .card-clases:hover,
.light-theme .card-registro:hover,
.light-theme .card-evaluaciones:hover,
.light-theme .card-apoyo:hover,
.light-theme .card-tutorias:hover {
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.18) 0%,
      rgba(79, 172, 254, 0.14) 100%);
}

/* ============================================================================
   BORDES Y SOMBRAS HOVER PERSONALIZADOS (COMENTADOS - USO FUTURO)
   ============================================================================ */

/* AZUL - Mis Clases */
/* .card-clases:hover {
  border-color: rgba(13, 78, 140, 0.5);
  box-shadow: 0 8px 24px rgba(13, 78, 140, 0.25);
} */

/* ROJO - Progreso Académico */
/* .card-registro:hover {
  border-color: rgba(188, 35, 54, 0.5);
  box-shadow: 0 8px 24px rgba(188, 35, 54, 0.25);
} */

/* AMARILLO - Evaluaciones */
/* .card-evaluaciones:hover {
  border-color: rgba(241, 196, 0, 0.5);
  box-shadow: 0 8px 24px rgba(241, 196, 0, 0.3);
} */

/* VERDE - Apoyo Estudiantil */
/* .card-apoyo:hover {
  border-color: rgba(52, 199, 89, 0.5);
  box-shadow: 0 8px 24px rgba(52, 199, 89, 0.25);
} */

/* CYAN - Tutorías */
/* .card-tutorias:hover {
  border-color: rgba(79, 172, 254, 0.5);
  box-shadow: 0 8px 24px rgba(79, 172, 254, 0.25);
} */

/* ============================================================================
   BORDES Y SOMBRAS HOVER UNIVERSAL AZUL (ACTIVO)
   ============================================================================ */
.card-clases:hover,
.card-registro:hover,
.card-evaluaciones:hover,
.card-apoyo:hover,
.card-tutorias:hover {
  border-color: rgba(13, 78, 140, 0.5);
  box-shadow: 0 8px 24px rgba(13, 78, 140, 0.25);
}

/* ============================================================================
   LÍNEAS DECORATIVAS PERSONALIZADAS (COMENTADAS - USO FUTURO)
   ============================================================================ */

/* AZUL - Mis Clases */
/* .card-clases .card-top-line,
.card-clases .card-bottom-line {
  background: linear-gradient(90deg, var(--app-primary-blue) 0%, rgba(79, 172, 254, 1) 100%);
} */

/* ROJO - Progreso Académico */
/* .card-registro .card-top-line,
.card-registro .card-bottom-line {
  background: linear-gradient(90deg, var(--app-primary-red) 0%, rgba(220, 60, 80, 1) 100%);
} */

/* AMARILLO - Evaluaciones */
/* .card-evaluaciones .card-top-line,
.card-evaluaciones .card-bottom-line {
  background: linear-gradient(90deg, var(--app-primary-yellow) 0%, rgba(255, 215, 0, 1) 100%);
} */

/* VERDE - Apoyo Estudiantil */
/* .card-apoyo .card-top-line,
.card-apoyo .card-bottom-line {
  background: linear-gradient(90deg, rgba(52, 199, 89, 1) 0%, rgba(93, 226, 120, 1) 100%);
} */

/* CYAN - Tutorías */
/* .card-tutorias .card-top-line,
.card-tutorias .card-bottom-line {
  background: linear-gradient(90deg, rgba(79, 172, 254, 1) 0%, rgba(0, 242, 254, 1) 100%);
} */

/* ============================================================================
   LÍNEAS DECORATIVAS UNIVERSAL AZUL (ACTIVO)
   ============================================================================ */
.card-clases .card-top-line,
.card-clases .card-bottom-line,
.card-registro .card-top-line,
.card-registro .card-bottom-line,
.card-evaluaciones .card-top-line,
.card-evaluaciones .card-bottom-line,
.card-apoyo .card-top-line,
.card-apoyo .card-bottom-line,
.card-tutorias .card-top-line,
.card-tutorias .card-bottom-line {
  background: linear-gradient(90deg, var(--app-primary-blue) 0%, rgba(79, 172, 254, 1) 100%);
}

.card-content-secondary {
  position: relative;
  z-index: 2;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1.5rem 2rem;
}

.card-icon-small {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 14px;
  margin: 0 auto 0.75rem;
  transition: var(--transition);
}

/* ============================================================================
   ICONOS PERSONALIZADOS POR COLOR (COMENTADOS - USO FUTURO)
   ============================================================================ */

/* AZUL - Mis Clases */
/* .card-clases .card-icon-small {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.3) 0%, rgba(79, 172, 254, 0.3) 100%);
  color: rgba(79, 172, 254, 1);
} */

/* ROJO - Progreso Académico */
/* .card-registro .card-icon-small {
  background: linear-gradient(135deg, rgba(188, 35, 54, 0.3) 0%, rgba(220, 60, 80, 0.3) 100%);
  color: rgba(220, 60, 80, 1);
} */

/* AMARILLO - Evaluaciones */
/* .card-evaluaciones .card-icon-small {
  background: linear-gradient(135deg, rgba(241, 196, 0, 0.3) 0%, rgba(255, 215, 0, 0.3) 100%);
  color: rgba(255, 215, 0, 1);
} */

/* VERDE - Apoyo Estudiantil */
/* .card-apoyo .card-icon-small {
  background: linear-gradient(135deg, rgba(52, 199, 89, 0.3) 0%, rgba(93, 226, 120, 0.3) 100%);
  color: rgba(52, 199, 89, 1);
} */

/* CYAN - Tutorías */
/* .card-tutorias .card-icon-small {
  background: linear-gradient(135deg, rgba(79, 172, 254, 0.3) 0%, rgba(0, 242, 254, 0.3) 100%);
  color: rgba(79, 172, 254, 1);
} */

/* ============================================================================
   ICONOS UNIVERSAL AZUL (ACTIVO)
   ============================================================================ */
.card-clases .card-icon-small,
.card-registro .card-icon-small,
.card-evaluaciones .card-icon-small,
.card-apoyo .card-icon-small,
.card-tutorias .card-icon-small {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.3) 0%, rgba(79, 172, 254, 0.3) 100%);
  color: rgba(79, 172, 254, 1);
}

.secondary-card:hover .card-icon-small {
  transform: scale(1.1);
}

.card-title-secondary {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow:
    0 2px 4px rgba(0, 0, 0, 0.1),
    0 4px 8px rgba(13, 78, 140, 0.15),
    0 1px 2px rgba(255, 255, 255, 0.1);
}

.card-subtitle-secondary {
  margin: 0;
  font-weight: 700;
  /* font-style: italic; */
  letter-spacing: 1.3px;
  display: inline-block;
}

/* Responsive */
@media (max-width: 768px) {

  .progress-container {
    padding: 1.25rem;
    border-radius: 18px;
    gap: 0.875rem;
  }

  .bear-gif {
    width: 40px;
    height: 40px;
  }

  .progress-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .progress-percentage {
    font-size: 1.35rem;
    align-self: flex-end;
  }

  .progress-label {
    font-size: 0.95rem;
  }

  .progress-bar-bg {
    height: 12px;
  }

  .progress-description {
    font-size: 0.8125rem;
  }

  .progress-status {
    font-size: 0.85rem;
  }

  .dashboard-container {
    gap: 1rem;
  }

  .main-card,
  .secondary-card {
    padding: 0;
    width: 100%;
  }

  .card-content {
    padding: 1.5rem;
  }

  .card-content-secondary {
    padding: 1.5rem;
  }

  .card-title {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .dashboard-container {
    gap: 1rem;
  }

  .progress-bar-wrapper {
    margin-top: 1rem;
  }

  .main-card,
  .secondary-card {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .card-content {
    padding: 1.25rem;
  }

  .card-content-secondary {
    padding: 1.25rem;
  }

  .progress-container {
    padding: 1rem;
    border-radius: 14px;
    gap: 0.75rem;
  }

  .bear-gif {
    width: 36px;
    height: 36px;
  }

  .progress-label {
    font-size: 0.875rem;
  }

  .progress-label svg {
    width: 18px;
    height: 18px;
  }

  .progress-percentage {
    font-size: 1.25rem;
    margin-top: -35px;
  }

  .progress-bar-bg {
    height: 10px;
  }

  .progress-description {
    font-size: 0.7rem;
  }

  .progress-status {
    font-size: 0.8rem;
    gap: 0.5rem;
  }

  .progress-status svg {
    width: 18px;
    height: 18px;
  }

  .btn-theme-toggle,
  .btn-refresh {
    width: 40px;
    height: 40px;
  }

  .card-icon-wrapper {
    width: 64px;
    height: 64px;
  }

  .card-icon {
    width: 36px;
    height: 36px;
  }

  .card-title {
    font-size: 1.35rem;
  }

  .card-description {
    font-size: 1rem;
  }

  .card-title-secondary {
    font-size: 1.1rem;
  }

  .card-desc-secondary {
    font-size: 0.875rem;
  }
}
</style>